import { render, staticRenderFns } from "./editAdmin.vue?vue&type=template&id=2838ead9&scoped=true&"
import script from "./editAdmin.vue?vue&type=script&lang=js&"
export * from "./editAdmin.vue?vue&type=script&lang=js&"
import style0 from "./editAdmin.vue?vue&type=style&index=0&id=2838ead9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2838ead9",
  null
  
)

export default component.exports